import type { WidgetConfig } from './widget-config';

export type AutolaunchTelemetryType =
  | 'impression'
  | 'opened'
  | 'dismissed'
  | 'assistant_greet_sent'
  | 'user_replied'
  | 'cta_clicked';

export type AutolaunchTelemetryPayload = {
  type: AutolaunchTelemetryType;
  session_id?: string;
  path?: string;
  lang?: string;
  config_id?: string | null;
  message_id?: string | null;
};

function telemetryUrl(config: Pick<WidgetConfig, 'apiOrigin'>): string {
  const base = config.apiOrigin.replace(/\/$/, '');
  return `${base}/api/engage/telemetry/autolaunch`;
}

/** Best-effort autolaunch analytics (legacy `autolaunch-events` parity). */
export function trackAutolaunchEvent(
  config: Pick<WidgetConfig, 'apiOrigin' | 'tenantId' | 'siteId'>,
  payload: AutolaunchTelemetryPayload,
): void {
  if (typeof fetch === 'undefined') {
    return;
  }

  const body = {
    tenant_id: config.tenantId,
    site_id: config.siteId,
    type: payload.type,
    session_id: payload.session_id ?? '',
    path: payload.path ?? (typeof window !== 'undefined' ? window.location.pathname : ''),
    lang:
      payload.lang ??
      (typeof navigator !== 'undefined' ? navigator.language || '' : ''),
    config_id: payload.config_id ?? null,
    message_id: payload.message_id ?? null,
  };

  void fetch(telemetryUrl(config), {
    method: 'POST',
    headers: { 'content-type': 'application/json', accept: 'application/json' },
    credentials: 'omit',
    body: JSON.stringify(body),
    keepalive: true,
  }).catch(() => {
    /* telemetry must not break the widget */
  });
}
